export default
    () => {
        return {
            zcierres: []
        }
    }
